const menuEnglish = {
  customerSwitcher: {
    workingAs: "Working as:",
    yourself: "Yourself",
    onBehalfBanner: "You are working on behalf of {customerName}"
  },
  menuItems: {
    dashboard: "Dashboard",
    linkedInPosts: "LinkedIn Posts",
    aiGenerator: "AI Generator",
    caseGenerator: "Case Generator",
    myPosts: "My Posts",
    imageArchive: "Image Archive",
    scheduler: "Scheduler",
    aiSettings: "AI Settings",
    settings: "Settings",
    organization: "Organization"
  },
  theme: {
    lightTheme: "Light theme",
    darkTheme: "Dark theme"
  },
  userMenu: {
    billing: "Billing",
    logout: "Log out"
  }
};

export default menuEnglish; 